import React, { FC } from 'react'

import { concatClassNames } from '../../utils'

import { Row } from '../row'
import { Text } from '../text'

import { useStyle } from './features-details-item.styles'
import { FeaturesDetailsItemProps } from './features-details-item.types'

export const FeaturesDetailsItem: FC<FeaturesDetailsItemProps> = ({
  className = '',
  label,
  labelTx,
  text,
  tx
}) => {
  const classes = useStyle()

  return (
    <Row
      wrap
      fullWidth
      className={concatClassNames(classes.featuresRow, className)}
      justifyContent="flex-start"
    >
      {label && (
        <Text color="inactive" preset="secondTitle" text={label} tx={labelTx} />
      )}
      <Text color="black" preset="h7" text={text} tx={tx} />
    </Row>
  )
}
